import { render, staticRenderFns } from "./SubscribePlanCardV2.vue?vue&type=template&id=0f4af782&scoped=true&"
import script from "./SubscribePlanCardV2.vue?vue&type=script&lang=js&"
export * from "./SubscribePlanCardV2.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePlanCardV2.vue?vue&type=style&index=0&id=0f4af782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4af782",
  null
  
)

export default component.exports